export default __webpack_public_path__ + "static/media/s_gts3.7900e761.jpg";